import { render, staticRenderFns } from "./game_version.vue?vue&type=template&id=94999b60&scoped=true&"
import script from "./game_version.vue?vue&type=script&lang=js&"
export * from "./game_version.vue?vue&type=script&lang=js&"
import style0 from "./game_version.vue?vue&type=style&index=0&id=94999b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94999b60",
  null
  
)

export default component.exports